import React from "react";
import CommonContainer from "../../../components/shared/CommonContainer";
import {
  Box,
  Heading,
  Stack,
  Text,
  HStack,
  Button,
  Flex,
  TableContainer,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  StackDivider,
} from "@chakra-ui/react";
import Countdown from "../../../components/freelancer/order/Countdown";

export default function FreelancerActiveOrderPage() {
  return (
    <CommonContainer>
      <Stack my={20}>
        <HStack
          justifyContent="end"
          pb={10}
          display={{ base: "none", "2xl": "flex" }}
        >
          <Button
            bg="brand.500"
            borderRadius={10}
            color="white"
            px={10}
            py={6}
            _hover={{ bg: "brand.400", color: "white" }}
          >
            Deliver Your Order
          </Button>
        </HStack>
        <Flex gap={5} flexDirection={{ base: "column", "2xl": "row" }}>
          <Stack
            flex={2}
            pt={5}
            px={{ base: 0, md: 5 }}
            gap={4}
            border="1px solid #c5c5c5"
            borderRadius={10}
            overflow="hidden"
          >
            <HStack
              justifyContent={"space-between"}
              flexDir={{ base: "column", lg: "row" }}
            >
              <Heading
                fontWeight="bold"
                fontSize={{ base: "24px", lg: "26px" }}
              >
                Order# FO0000225
              </Heading>
              <HStack
                color="#c5c5c5"
                fontSize="13px"
                fontWeight={"medium"}
                divider={<StackDivider />}
                gap={4}
                flexWrap="wrap"
              >
                <Text color="brand.500">View Gig</Text>
                <Text display={{ base: "none", md: "block" }}>
                  Buyer:
                  <Box px={2} as="span" color="brand.500">
                    lgwe100
                  </Box>
                  (View History)
                </Text>
                <Text>Dec 02, 2017</Text>
              </HStack>
              <Text display={{ base: "block", md: "none" }}>
                Buyer:
                <Box px={2} as="span" color="brand.500">
                  lgwe100
                </Box>
                (View History)
              </Text>
            </HStack>
            <Flex justifyContent={"space-between"} gap={5} flexWrap="wrap">
              <Heading
                fontWeight="bold"
                fontSize={{ base: "30px", lg: "32px" }}
                color="brand.500"
                w="full"
                textAlign={{ base: "center", md: "start" }}
              >
                $55.00
              </Heading>
              <TableContainer
                border="1px solid #c5c5c5"
                mb={6}
                borderRadius={10}
                display={{ base: "none", md: "flex" }}
                w="full"
              >
                <Table>
                  <Thead>
                    <Tr>
                      <Th>Item</Th>
                      <Th>Quantity</Th>
                      <Th>Duration</Th>
                      <Th>Amount</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    <Tr>
                      <Td>research and suggest private labels to amazon</Td>
                      <Td>1</Td>
                      <Td>4 Days</Td>
                      <Td>$ 55.00</Td>
                    </Tr>
                    <Tr>
                      <Td></Td>
                      <Td></Td>
                      <Td>Total</Td>
                      <Td>$ 55.00</Td>
                    </Tr>
                  </Tbody>
                </Table>
              </TableContainer>
              <Stack
                borderRadius={10}
                display={{ base: "flex", md: "none" }}
                spacing={0}
                w="full"
                color="#8D7786"
              >
                <HStack
                  w="full"
                  spacing={0}
                  borderBottom="1px"
                  borderTop="1px"
                  borderColor="#c5c5c5"
                >
                  <Box
                    w="30%"
                    h="80px"
                    bg="#f4f4f4"
                    borderRight="1px"
                    borderColor="#c5c5c5"
                  ></Box>
                  <Flex
                    alignItems="center"
                    w="70%"
                    h="80px"
                    bg="#f4f4f4"
                    fontSize="20px"
                    px={4}
                  >
                    Item
                  </Flex>
                </HStack>
                <HStack
                  w="full"
                  spacing={0}
                  borderBottom="1px"
                  borderColor="#c5c5c5"
                >
                  <Flex
                    alignItems="center"
                    justifyContent="center"
                    w="30%"
                    h="50px"
                    bg="#f4f4f4"
                    borderRight="1px"
                    borderColor="#c5c5c5"
                  ></Flex>
                  <Box
                    w="70%"
                    p={3}
                    h="50px"
                    fontSize={{ base: "12px", md: "16px" }}
                  >
                    research and suggest private labels to amazon
                  </Box>
                </HStack>
                <HStack
                  w="full"
                  spacing={0}
                  borderBottom="1px"
                  borderColor="#c5c5c5"
                >
                  <Flex
                    alignItems="center"
                    justifyContent="center"
                    w="30%"
                    h="50px"
                    bg="#f4f4f4"
                    borderRight="1px"
                    borderColor="#c5c5c5"
                  >
                    Quantity
                  </Flex>
                  <Box w="70%" p={3} h="50px">
                    1
                  </Box>
                </HStack>
                <HStack
                  w="full"
                  spacing={0}
                  borderBottom="1px"
                  borderColor="#c5c5c5"
                >
                  <Flex
                    alignItems="center"
                    justifyContent="center"
                    w="30%"
                    h="50px"
                    bg="#f4f4f4"
                    borderRight="1px"
                    borderColor="#c5c5c5"
                  >
                    Duration
                  </Flex>
                  <Box w="70%" p={3} h="50px">
                    4 Days
                  </Box>
                </HStack>
                <HStack
                  w="full"
                  spacing={0}
                  borderBottom="1px"
                  borderColor="#c5c5c5"
                >
                  <Flex
                    alignItems="center"
                    justifyContent="center"
                    w="30%"
                    h="50px"
                    bg="#f4f4f4"
                    borderRight="1px"
                    borderColor="#c5c5c5"
                  >
                    Amount
                  </Flex>
                  <Box w="70%" p={3} h="50px">
                    $ 55.00
                  </Box>
                </HStack>
                <HStack w="full" spacing={0}>
                  <Flex
                    alignItems="center"
                    justifyContent="center"
                    w="30%"
                    h="50px"
                    bg="#f4f4f4"
                    borderRight="1px"
                    fontWeight="medium"
                    color="black"
                    borderColor="#c5c5c5"
                  >
                    Total:
                  </Flex>
                  <Box w="70%" p={3} h="50px">
                    $ 55.00
                  </Box>
                </HStack>
              </Stack>
            </Flex>
          </Stack>
          <HStack
            justifyContent="end"
            pb={10}
            display={{ base: "flex", "2xl": "none" }}
          >
            <Button
              bg="brand.500"
              borderRadius={10}
              color="white"
              px={10}
              py={6}
              _hover={{ bg: "brand.400", color: "white" }}
            >
              Deliver Your Order
            </Button>
          </HStack>
          <Stack
            flex={1}
            bg="#f4f4f4"
            height="full"
            minWidth={{ "2xl": "520px" }}
          >
            <Countdown />
          </Stack>
        </Flex>
        <HStack pt={10} gap={5} flexDir={{ base: "column", md: "row" }}>
          <Text fontSize={{ base: "16px", lg: "20px" }} color="#676767">
            Need to change or cancel your order?
          </Text>
          <Button
            bg="brand.500"
            borderRadius={10}
            color="white"
            px={10}
            py={6}
            _hover={{ bg: "brand.400", color: "white" }}
          >
            Visit The Resolution Center
          </Button>
        </HStack>
      </Stack>
    </CommonContainer>
  );
}
